import { FETCH_TYPE } from '../../actionTypes.js';
/** Requesting a fetch to begin
 *
 * @param fetchShape
 * @param param1 { params, body, throttle, updateParams }
 */

export default function createFetch(fetchShape, _ref) {
  let {
    params,
    body,
    throttle,
    updateParams
  } = _ref;
  const {
    schema,
    type,
    getFetchKey,
    options
  } = fetchShape;
  const key = getFetchKey(params);
  let resolve = 0;
  let reject = 0;
  const promise = new Promise((a, b) => {
    [resolve, reject] = [a, b];
  });
  const meta = {
    schema,
    type,
    args: [params, body],
    key,
    throttle,
    options,
    resolve,
    reject,
    promise,
    createdAt: Date.now()
  };

  if (fetchShape.update) {
    meta.update = fetchShape.update;
  } // for simplicity we simply override if updateParams are defined - usage together is silly to support as we are migrating


  if (updateParams) {
    meta.update = newresult => {
      const updateMap = {};
      updateParams.forEach(_ref2 => {
        let [toShape, toParams, updateFn] = _ref2;

        updateMap[toShape.getFetchKey(toParams)] = existing => updateFn(newresult, existing);
      });
      return updateMap;
    };
  }

  if (options != null && options.optimisticUpdate) {
    meta.optimisticResponse = options.optimisticUpdate(params, body);
  }

  return {
    type: FETCH_TYPE,
    payload: () => fetchShape.fetch(params, body),
    meta
  };
}